__turbopack_context__.v({
  "pLarge": "_1lWpUa_pLarge",
  "root": "_1lWpUa_root",
});
